import { Fetch } from 'lib';
import type { ShippingConfig } from 'types';

type RequestResponses = ShippingConfig;

type RequestParameters = {};

type RequestBody = Prettify<
  StrictOmit<
    ShippingConfig,
    'id' | 'products' | 'brands' | 'categories' | 'cities'
  > &
    Partial<
      Record<
        'productsIds' | 'brandsIds' | 'categoriesIds' | 'citiesIds',
        string[]
      >
    >
>;

const createShippingConfig = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminShippingConfig/createShippingConfig',
    method: 'POST',
    body,
  });

export { createShippingConfig };
